function checkTotalPrice() {
 var url = "/cart.json";
 var request = new XMLHttpRequest();
 var result = "";
 request.open("GET", url, false);
 request.onreadystatechange = function () {
     if (request.readyState != 4) {
         // リクエスト中
     } else if (request.status != 200) {
         // 失敗
     } else {
         // 取得成功
         result = request.responseText;
     }
 }
 request.send(null);
 let resultData = JSON.parse(result);
 var element = document.getElementById("cart-privileges");


  if(resultData.original_total_price > 600000){
   return true;
 } else {
   return false;
 }
 }


var privilege_counter = 0;


function setPrivilege(){
 if(privilege_counter == 0){
   // 「gift_lavons202604」のタグが付けられた商品を1点以上の時にギフト商品追加
   if (document.getElementById("giftCheckLAVONS202604") != null) { selectPrivilegeProductLAVONS202604('47363642884349'); }

   privilege_counter++;
 }
}

// //  5000円以上購入するとギフト商品追加される機能
// function selectPrivilegeProductOmake010(id){
//  //alert(id);
//  clearPrivilegeProduct(id);
//  const giftCheckOmake010 = document.getElementById("giftCheckOmake010").value;
//  if(giftCheckOmake010 == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//  }


//  return true;
// }


// // 「girt-target」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
// function selectPrivilegeProductGift02(id){
//  clearPrivilegeProduct(id);
//  const giftCheck02 = document.getElementById("giftCheck02").value;
//  if(giftCheck02 == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//  }


//  return true;
// }

// // 「gift-target」タグの付いた商品を1点以上で合計¥3,000以上の時にギフト商品追加される機能
// function selectPrivilegeProductGift(id){
//  clearPrivilegeProduct(id);
//  const giftCheck = document.getElementById("giftCheck").value;
//  if(giftCheck == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//  }


//  return true;
// }


// // 「girt-lavons2024」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
// function selectPrivilegeProductLavons2024(id){
//  //alert(id);
//  clearPrivilegeProduct(id);
//  const giftCheckLavons = document.getElementById("giftCheckLavons").value;
//  if(giftCheckLavons == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//    //alert(result);
//  }
//  //alert(giftCheckLavons);


//  return true;
// }


// // 「gift-KGMARO」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
// function selectPrivilegeProductKGMARO(id){
//  //alert(id);
//  clearPrivilegeProduct(id);
//  const giftCheckKGMARO = document.getElementById("giftCheckKGMARO").value;
//  if(giftCheckKGMARO == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//    //alert(result);
//  }
//  //alert(giftCheckMaroKG);


//  return true;
// }


// // 「gift_lavons202504」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
// function selectPrivilegeProductLAVONS202504(id){
//  //alert(id);
//  clearPrivilegeProduct(id);
//  const giftCheckLAVONS202504 = document.getElementById("giftCheckLAVONS202504").value;
//  var cartTotalPrice = parseInt(document.getElementById("cartTotalPrice").value);
//  var omakeNum = 0
//  //console.log(cartTotalPrice);


//  // 購入金額によっておまけの個数を変更する
//  if(cartTotalPrice > 0){
//    omakeNum = Math.floor(cartTotalPrice / 300000);
//  } else {
//    omakeNum = 0;
//  }
//  //alert(omakeNum);
//   if(giftCheckLAVONS202504 == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": omakeNum,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//    //alert(result);
//  }
//  //alert(giftCheckMaroKG);


//  return true;
// }


// 金額ごとにおまけを増やしたい場合のテンプレート
function selectPrivilegeProductTargetDiane(id){
 //alert(id);
 clearPrivilegeProduct(id);
 const giftCheckTargetDiane = document.getElementById("giftCheckTargetDiane").value;
 var cartTotalPrice = parseInt(document.getElementById("cartTotalPrice").value);
 var omakeNum = 0
 //console.log(cartTotalPrice);


 // 購入金額によっておまけの個数を変更する
 if(cartTotalPrice > 400000){
   omakeNum = 1;
 }
 //alert(omakeNum);
  if(giftCheckTargetDiane == "true") {
   var data =  {
     items: [
       {
         "id": parseInt(id),
         "quantity": omakeNum,
       },
     ],
   }


   var url = "/cart/add.js";
   var request = new XMLHttpRequest();
   var result = "";
   request.onreadystatechange = function() {
     if (request.readyState != 4) {
       // リクエスト中
     } else if (request.status != 200) {
       // 失敗
     } else {
       // 取得成功
       result = request.responseText;
     }
   }


   request.open('POST', url, false);
   request.setRequestHeader('Content-Type', 'application/json');
   request.send(JSON.stringify(data));
   //alert(result);
 }
 //alert(giftCheckMaroKG);


 return true;
}



// function selectPrivilegeProductLAVONS202503(id){
//  //alert(id);
//  clearPrivilegeProduct(id);
//  const giftCheckLAVONS202503 = document.getElementById("giftCheckLAVONS202503").value;
//  if(giftCheckLAVONS202503 == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//    //alert(result);
//  }
//  //alert(giftCheckMaroKG);


//  return true;
// }


// function selectPrivilegeProduct(id){
//  clearPrivilegeProduct(id);
//  var checkPriceFlg = checkTotalPrice();


//  if(checkPriceFlg){
//    var data =  {
//      items: [
//        {
//          "id": id,
//          "quantity": 1,
//        },
//      ],
//    }
//    //console.log(data);


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//   }
//   return true;
//  }


// function clearPrivilegeProduct(id){

//  // 対象の特典が含まれているかを判定(含まれなかったら処理を中断)
//  var giftCheckFlag = document.getElementById("giftInCartFlag")?.value;
//  if (giftCheckFlag !== "true") {
//   return false;
//  }

//  var data =  {
//    'id': id,
//    'quantity': 0,
//  };
//   var url = "/cart/change.js";
//  var request = new XMLHttpRequest();
//  var result = "";
//  request.onreadystatechange = function() {
//    if (request.readyState != 4) {
//      // リクエスト中
//    } else if (request.status != 200) {
//      // 失敗
//    } else {
//      // 取得成功
//      result = request.responseText;
//    }
//  }
//  request.open('POST', url, false);
//  request.setRequestHeader('Content-Type', 'application/json');
//  request.send(JSON.stringify(data));
//  }


// // 「gift-target-lavons202506CP」のタグが付いた商品を1個以上購入するとギフト商品追加される機能
// function selectPrivilegeProductTargetlavons202506CP(id){
//  clearPrivilegeProduct(id);
//  const giftCheckTargetLavons = document.getElementById("giftCheckTargetLavons").value;
//  var cartTotalPrice = parseInt(document.getElementById("cartTotalPrice").value);
//  var omakeNum = 1;


//  if (giftCheckTargetLavons === "true" && omakeNum > 0) {
//    var data = {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": omakeNum,
//        },
//      ],
//    };


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    request.onreadystatechange = function () {
//      if (request.readyState === 4 && request.status === 200) {
//        // 成功
//      }
//    };


//    request.open("POST", url, false);
//    request.setRequestHeader("Content-Type", "application/json");
//    request.send(JSON.stringify(data));
//  }


//  return true;
// }


// // 「gift-lavons202509」タグの付いた商品を1点以上で合計¥2,000以上の時にギフト商品追加される機能
// function selectPrivilegeProductLAVONS202509(id){
//  clearPrivilegeProduct(id);
//  const giftCheck = document.getElementById("giftCheckLAVONS202509").value;
//  if(giftCheck == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }


//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }


//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//  }


//  return true;
// }

// // 「gift_lavons202601」タグの付いた商品を1点以上で合計¥5,000以上の時にギフト商品追加される機能
// function selectPrivilegeProductLAVONS202601(id){
//  clearPrivilegeProduct(id);
//  const giftCheck = document.getElementById("giftCheckLAVONS202601").value;
//  if(giftCheck == "true") {
//    var data =  {
//      items: [
//        {
//          "id": parseInt(id),
//          "quantity": 1,
//        },
//      ],
//    }

//    var url = "/cart/add.js";
//    var request = new XMLHttpRequest();
//    var result = "";
//    request.onreadystatechange = function() {
//      if (request.readyState != 4) {
//        // リクエスト中
//      } else if (request.status != 200) {
//        // 失敗
//      } else {
//        // 取得成功
//        result = request.responseText;
//      }
//    }

//    request.open('POST', url, false);
//    request.setRequestHeader('Content-Type', 'application/json');
//    request.send(JSON.stringify(data));
//  }

//  return true;
// }

// 「gift_lavons202604」タグの付いた商品を1点以上で合計4,000以上の時にギフト商品追加される機能
function selectPrivilegeProductLAVONS202604(id){
 clearPrivilegeProduct(id);
 const giftCheck = document.getElementById("giftCheckLAVONS202604").value;
 if(giftCheck == "true") {
   var data =  {
     items: [
       {
         "id": parseInt(id),
         "quantity": 1,
       },
     ],
   }

   var url = "/cart/add.js";
   var request = new XMLHttpRequest();
   var result = "";
   request.onreadystatechange = function() {
     if (request.readyState != 4) {
       // リクエスト中
     } else if (request.status != 200) {
       // 失敗
     } else {
       // 取得成功
       result = request.responseText;
     }
   }

   request.open('POST', url, false);
   request.setRequestHeader('Content-Type', 'application/json');
   request.send(JSON.stringify(data));
 }

 return true;
}

function clearPrivilegeProduct(id) {

  // 特典追加時にこの配列に商品idを追加する
  const giftIds = [
    43471872590077, 43882883940605, 43885399343357,
    44258149630205, 45718842736893, 45839098249469,
    46062294139133, 46145122366397, 46214134366461,
    45804081283325, 46323647709437, 46616957616381,
    47027703644413, 47363642884349
  ];

  // cart.jsで現在のカート状態を確認
  const cartReq = new XMLHttpRequest();
  cartReq.open('GET', '/cart.js', false); // 同期
  cartReq.send();

  if (cartReq.status !== 200) return false;

  const cart = JSON.parse(cartReq.responseText);
  const hasGift = cart.items.some(item => giftIds.includes(item.id));

  if (!hasGift) return false;

  // 削除処理
  const data = { id: id, quantity: 0 };
  const request = new XMLHttpRequest();
  request.open('POST', '/cart/change.js', false);
  request.setRequestHeader('Content-Type', 'application/json');
  request.send(JSON.stringify(data));
}
